import React from 'react';
import { Snackbar, Paper, Box, Typography, LinearProgress } from '@mui/material';

interface DownloadProgressSnackbarProps {
  open: boolean;
  progress?: number;
}

const DownloadProgressSnackbar: React.FC<DownloadProgressSnackbarProps> = ({ open, progress }) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ mb: 1, mr: 1, zIndex: 10000 }}
    >
      <Paper
        elevation={6}
        sx={{
          width: 360,
          height: 60,
          borderRadius: 1,
          overflow: 'hidden',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', px: 2, py: 2.2, gap: 1 }}>
          <img src="/images/info-circle-solid.svg" alt="info" width={16} height={16} />
          <Typography variant="body1" fontWeight={400} fontSize={14}>
            Downloading in progress
          </Typography>
        </Box>

        <LinearProgress
          variant={progress !== undefined ? 'determinate' : 'indeterminate'}
          value={progress}
        />
      </Paper>
    </Snackbar>
  );
};

export default DownloadProgressSnackbar;
